"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GET_BRANDING_SETTINGS = exports.DEFAULT_BRANDING = void 0;
var DEFAULT_BRANDING = exports.DEFAULT_BRANDING = {
  secondary: {
    block: {
      accent: 'rgb(0, 54, 115)',
      container: 'rgb(0, 80, 171)'
    }
  },
  fonts: {
    heading: {
      name: 'Helvetica',
      url: ''
    },
    body: {
      name: 'Helvetica',
      url: ''
    }
  }
};
var GET_BRANDING_SETTINGS = exports.GET_BRANDING_SETTINGS = 'GET_BRANDING_SETTINGS';